import { ReactNode } from 'react';
import styled from '@emotion/styled';

const Main = styled.section`
  position: relative;
`;

const Title = styled.h1`
  margin: 0;
  font-weight: 600;
  font-size: 27px;
  line-height: 122%;
  letter-spacing: 0.41px;
  margin-top: 40px;
`;

interface PaywallHeaderProps {
  children?: ReactNode;
}

export function PaywallHeader({ children = 'Try Premium' }: PaywallHeaderProps) {
  return (
    <Main>
      <Title>{children}</Title>
    </Main>
  );
}
